import PropTypes from 'prop-types';

export default PropTypes.shape({
  key: PropTypes.string.isRequired,
  defaultValue: PropTypes.bool.isRequired
});



// WEBPACK FOOTER //
// ./src/shapes/permission.js